export default __webpack_public_path__ + "static/media/logo_avatar_05.2545ec97.png";